import ConfigurationEmailListController from './configuration.email.list.controller';
import ConfigurationEmailListHtml from './configuration.email.list.html';

export default {
	controller: ConfigurationEmailListController,
	// template: require('./configuration.email.list.html')
	template: ConfigurationEmailListHtml
};
